import { lazy } from "react";

export { CALENDAR_PATH } from "./calendar-path";
export const CalendarPage = lazy(
  () => import(/* webpackChunkName: "calendar" */ "./calendar"),
);
